import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const CheckCircleIcon = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={mergeClassNames('w-4 h-4 text-red-400', className)}
    {...props}
  >
    <path d="M21.801 10A10 10 0 1 1 17 3.335" />
    <path d="m9 11 3 3L22 4" />
  </svg>
);

export default CheckCircleIcon;
